import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AgGridAngular} from 'ag-grid-angular';

import {moduloCobrosAutoservicio} from '../../../diccionarios/cobrosAutoServiciosModulo';
import {
  ParametroConciliacionBancariaService
} from "../../../services/conciliacion-bancaria/parametro-conciliacion-bancaria.service";
import {CobrosAutoserviciosService} from '../../../services/cobrosAutoservicio/cobros-autoservicios.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {InputSearchService} from '../../../services/inputSearch/input-search.service';
import {DatosMaestrosService} from 'src/app/services/datos-maestros.service';
// import * as jQuery from 'jquery';
declare var $: any;

@Component({
  selector: 'app-sistema-cobros-autoservicios',
  templateUrl: './sistema-cobros-autoservicios.component.html',
  styleUrls: ['./sistema-cobros-autoservicios.component.css']
})
export class SistemaCobrosAutoserviciosComponent implements OnInit {

  @ViewChild('pngInput') pngInput: ElementRef;
  @ViewChild('agGrid') agGrid: AgGridAngular;

  columnDefs: any[];
  rowData: any[];
  frameworkComponents: any;
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  textoBuscar: string;
  getRowNodeId: any;
  formulario: FormGroup;
  formularioEditar: FormGroup;

  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  //combos
  cmbEmpresa: any[];
  cmbBanco: any[];
  cmbEstructura: any[];
  cmbCuenta: any[];
  cmbTipoPago: any[];
  cmbClientVinculado: { id: boolean; valor: string; }[];
  //bloquear campos
  BloquearCampo: boolean = true;
  bloquearCheque: boolean = false;
  //mostrar formularios
  mostrarFormularioProcesar = true;
  mostrarFormularioGuardar = false;
  mostrarFormularioEditar = false;

  //dataClienete
  dataCliente: any = {};
  textBoton = '';
  btnGuardar = true;
  cobroAutoModulo: any = {};
  BloquearCombo: boolean = false;

  rowDataModal: any[] = [];
  rowSelectionModal: string;
  frameworkComponentsModal: any;
  formularioModal: FormGroup;
  columnDefsModal: any;
  loading: boolean;
  mostrar: boolean;

  constructor(private fb: FormBuilder,
              private _cobrosAutoservicios: CobrosAutoserviciosService,
              private _conciliacionBancaria: ParametroConciliacionBancariaService,
              private _inputSearch: InputSearchService,
              private _datosMaestros: DatosMaestrosService,
              private _util: UtilsService) {
    this.cmbClientVinculado = [{id: true, valor: 'Si'}, {id: false, valor: 'No'}];
    this.cobroAutoModulo = moduloCobrosAutoservicio;

    this.DAT_BTNS = this.cobroAutoModulo.button.buttonsNombre;
    this.DAT_MSG = this.cobroAutoModulo.mensajes;
    this.DAT_BTNCSS = this.cobroAutoModulo.button.buttonsCss;

    // this.DAT_BTNS = this.cobroAutoModulo.button.buttonsNombre;
    // this.DAT_MSG = this.cobroAutoModulo.mensajes;
    this.cargarEmpresa();
    this.cargarTipoEstructura();
    this.cargarTipoPago();
    this.cargarComponentesModal();

  }

  ngOnInit() {
    this.formulario = this.fb.group({
      idEmpresa: ['', [Validators.required]],
      idCliente: ['', [Validators.required]],
      clientVinculado: ['', [Validators.required]],
      idClientePadre: ['', [Validators.required]],
      dscaClientePadre: [''],
      idParamCobrosAutoServ: ['', [Validators.required]],
      idViaPago: ['', [Validators.required]],
      idBanco: ['', [Validators.required]],
      //claveBanco: ['',[Validators.required]],
      ctaBancaria: ['', [Validators.required]],
      numCheque: ['', [Validators.required, Validators.min(1), Validators.minLength(7), Validators.maxLength(30)]],//numCheque numRecaudacion
      fechaDocumento: ['', [Validators.required]],
      valorPago: ['', [Validators.required, Validators.min(0), Validators.minLength(2), Validators.maxLength(22)]],
      referencia: ['', [Validators.required, Validators.min(1), Validators.maxLength(50)]],
      file: [null, [Validators.required]],
      sustento: [null, []],
      urlSustento: [false],
    });

    this.formularioEditar = this.fb.group({
      noLinea: [''],
      idTipoTrans: ['', [Validators.maxLength(3)]],
      noDocumento: ['', [Validators.min(1), Validators.maxLength(50)]],
      idCliente: ['', [Validators.required]],
      fechaRegistro: [''],
      status: [''],
      valorCobro: [''],
      valorDiferencia: [''],
      valorFacturaFabril: [''],
      dscaCliente: ['', [Validators.required]],
    });

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Modificar',
        field: 'modificar',
        cellRenderer: 'buttonRenderer',
        width: 140,
        cellRendererParams: {
          onClick: this.abrirFormularioParaEditarHTML.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: 'N°lINEA',
        field: 'noLinea',
        filter: true,
        width: 115
      },
      {
        headerName: 'TIPO',
        field: 'idTipoTrans',
        filter: true,
        width: 100
      },
      {
        headerName: 'N° DOCUMENTO',
        field: 'noDocumento',
        filter: true,
        width: 200
      },
      {
        headerName: 'CLIENTE',
        field: 'idCliente',
        filter: true,
        width: 200
      },
      {
        headerName: 'NOMBRE',
        field: 'dscaCliente',
        filter: true,
        width: 250
      },
      {
        headerName: 'STATUS',
        field: 'status',
        filter: true,
        width: 250
      },
      {
        headerName: 'VALOR FACT ANT',
        field: 'valorFacturaFabril',
        filter: true,
        width: 210
      },
      {
        headerName: 'VALOR COBRO',
        field: 'valorCobro',
        filter: true,
        width: 200
      },
      {
        headerName: 'VALOR FACT ACT',
        field: 'valorFacturaDes',
        filter: true,
        width: 210
      },
      {
        headerName: 'VALOR ANTICIPO',
        field: 'valorAnticipo',
        filter: true,
        width: 200
      }
    ];
    this.rowSelection = 'multiple';
    this.getRowNodeId = function (data) {
      return data.noLinea;
    };
    // $(document).ready(() => {
    //   $('body').removeClass('modal-open');
    //   $('.modal-backdrop').remove();
    // });
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  abrirFormularioParaEditarHTML({rowData}) {
    this.mostrarFormularioEditar = true;
    this.mostrarFormularioGuardar = false;
    this.mostrarFormularioProcesar = false;
    this.formularioEditar.get('noLinea').setValue((rowData.noLinea === undefined) ? '' : rowData.noLinea);
    this.formularioEditar.get('idTipoTrans').setValue((rowData.idTipoTrans === undefined) ? '' : rowData.idTipoTrans);
    this.formularioEditar.get('noDocumento').setValue((rowData.noDocumento === undefined) ? '' : rowData.noDocumento);
    this.formularioEditar.get('idCliente').setValue((rowData.idCliente === undefined) ? '' : rowData.idCliente);
    this.formularioEditar.get('fechaRegistro').setValue((rowData.fechaRegistro === undefined) ? '' : rowData.fechaRegistro);
    this.formularioEditar.get('status').setValue((rowData.status === undefined) ? '' : rowData.status);
    this.formularioEditar.get('valorCobro').setValue((rowData.valorCobro === undefined) ? '' : rowData.valorCobro);
    this.formularioEditar.get('valorDiferencia').setValue((rowData.valorDiferencia === undefined) ? '' : rowData.valorDiferencia);
    this.formularioEditar.get('valorFacturaFabril').setValue((rowData.valorFacturaFabril === undefined) ? '' : rowData.valorFacturaFabril);
    this.formularioEditar.get('dscaCliente').setValue((rowData.dscaCliente === undefined) ? '' : rowData.dscaCliente);
  }

  async btnEditarForm() {
    let data = this.formularioEditar.value;
    if ((data.noDocumento == null && data.idTipoTrans == null) || (data.noDocumento == '' && data.idTipoTrans == '')) {
      this._util.confirmarSincronoPromesaAction(
        {
          title: this.DAT_MSG.actualizar,
          text: this.DAT_MSG.anticipo,
          action: this.DAT_BTNS.editar,
        },
        () => {
          this.editDetalle()
        }
      )
    } else if ((data.noDocumento == '' && data.idTipoTrans != '') || (data.noDocumento != '' && data.idTipoTrans == '')) {
      this._util.mensajeErrorVisto(this.DAT_MSG.camposObligatorio);
    } else {
      this.editDetalle();
    }
  }

  async editDetalle() {
    let newData = this.formularioEditar.value;
    let dataGrilla = this.rowData;
    dataGrilla = dataGrilla.filter((i) => i.noLinea !== newData.noLinea);
    dataGrilla.push(newData);
    this.rowData = dataGrilla;
    this.gridApi.setRowData(this.rowData);
    this.mostrarFormularioGuardar = true;
    this.mostrarFormularioProcesar = false;
    this.mostrarFormularioEditar = false;
  }

  cargarEmpresa() {
    this._datosMaestros.getAllEmpresas().subscribe((resp) => {
      console.log(resp);
      this.cmbEmpresa = resp;
      this.cmbCuenta = [];
      this.formulario.get('ctaBancaria').setValue('');
    }, (error) => {
      console.log(error);
    });
  }

  onCargarBanco(target) {
    let idEmpresa = this.formulario.get('idEmpresa').value;
    this._datosMaestros.getBancoPorEmpresa(idEmpresa).subscribe((resp) => {
      console.log(resp);
      let newData: any = this.concatenarBancoId(resp);
      this.cmbBanco = newData;
    }, (error) => {
      console.log(error);
    });
  }

  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }

  cargarTipoEstructura() {
    this._cobrosAutoservicios.getAll().subscribe((resp: any) => {
      this.cmbEstructura = resp;
    }, () => {
      this.cmbEstructura = [];
    });
  }

  onCargarCuentaClave(target) {
    let idEmpresa = this.formulario.get('idEmpresa').value;
    let idBanco = this.formulario.get('idBanco').value;
    this._datosMaestros.getCuentaPorBanco(idEmpresa, idBanco).subscribe((resp) => {
      this.formulario.get('ctaBancaria').setValue(resp.cuentaBancaria);
    }, (err) => {
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
    // this._cobrosAutoservicios.cargarClaveBanco( idEmpresa, idBanco ).subscribe((resp) => {
    //   console.log(resp);
    //   this.formulario.get('claveBanco').setValue(resp);
    // }, (err) => {
    //   console.log(err);
    //   this.formulario.get('claveBanco').setValue('');
    //   this._util.mensajeErrorVisto(err.error.mensaje);
    // });
  }

  onChequeObligatorio(target) {
    let idViaPago = this.formulario.get('idViaPago').value;
    if (idViaPago == 'P' || idViaPago == 'S' || idViaPago == 'C') {
      //alert('ES UN CHEQUE');
      this.bloquearCheque = false;
      this.formulario.get('numCheque').clearValidators();
      this.formulario.get('numCheque').setValidators([Validators.required, Validators.min(1), Validators.minLength(7), Validators.maxLength(30)]);
    } else {
      //alert('nell no ES UN CHEQUE');
      this.bloquearCheque = true;
      this.formulario.get('numCheque').clearValidators();
      this.formulario.get('numCheque').setValue(' ');
    }
  }

  cargarTipoPago() {
    this._cobrosAutoservicios.getTipoPago().subscribe((resp) => {
      this.cmbTipoPago = resp;
    });
  }

  setCliente($event) {
    let idCliente = $event.idCliente;
    this.formulario.get('idCliente').setValue(idCliente);
    this.getClienteViculado(idCliente);
  }

  setClienteEditar($event) {
    let data = $event;
    this.formularioEditar.get('idCliente').setValue(data.idCliente);
    this.formularioEditar.get('dscaCliente').setValue(data.nombreCliente1);
  }

  cargarClienteEditar(target) {
    let idCliente = this.formularioEditar.get('idCliente').value;
    this._cobrosAutoservicios.getCliente(idCliente).subscribe((resp) => {
      this.formularioEditar.get('dscaCliente').setValue(resp.nombreCliente1);
    }, (err) => {
      this._util.mensajeErrorVisto(err.error.mensaje);
      this.formularioEditar.get('dscaCliente').setValue('');
    });
  }

  cargarCliente($event) {
    // debugger
    let idCliente = this.formulario.get('idCliente').value;
    this.getClienteViculado(idCliente);
  }

  getClienteViculado(idCliente: string) {
    this._cobrosAutoservicios.getClienteVinculado(idCliente).subscribe((resp) => {
      console.log(resp);
      this.formulario.get('idClientePadre').setValue(resp.idClienteFather);
      this.formulario.get('clientVinculado').setValue(resp.vinculate);
      this.formulario.get('dscaClientePadre').setValue(resp.dscaClientePadre);
    }, (err) => {
      console.log(err);
      this._util.mensajeErrorVisto(err.error.mensaje);
      this.formulario.get('idClientePadre').setValue('');
      this.formulario.get('clientVinculado').setValue('');
      this.formulario.get('dscaClientePadre').setValue('');
    });
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (event.target.id == 'csvInput') {
        this.formulario.get('file').setValue(file);
      } else if (event.target.id == 'pngInput') {
        this.formulario.get('sustento').setValue(file);
      }
    }
    this.validacionArchivo();
  }

  validacionArchivo() {
    this.btnGuardar = true;
    let file = this.formulario.get('sustento').value;
    if (file != null) {
      this.btnGuardar = false;
      this.dataCliente.urlSustento = true;
    }
  }

  limpiarIputFile() {
    this.pngInput.nativeElement.value = '';
  }

  procesarArchivo() {
    let data = this.getFormData();
    return this._cobrosAutoservicios.procesarArchivo(data);
  }

  getFormData() {
    let obj = this.formulario.value;
    let clonObj = Object.assign({}, obj);
    // delete clonObj['dscaClientePadre'];
    // delete clonObj['numCheque'];
    // delete clonObj['sustento'];
    // delete clonObj['urlSustento'];
    const formData = new FormData();
    Object.keys(clonObj).forEach(key => formData.append(key, clonObj[key]));
    formData.delete('file');
    formData.append('file', new Blob([this.formulario.get('file').value], {type: 'text/csv'}), 'file');
    return formData;
  }

  clickSustento() {
    document.getElementById('pngInput').click();
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.mostrarFormularioProcesar) {
        console.log('procesando');
        this._util.confirmarSincronoPromesa({
          title: this.DAT_MSG.procesar,
          text: '',
          action: this.DAT_BTNS.procesar,
          funcion: this.procesarArchivo()
        })
          .then((response: any) => {
            this.mostrarFormularioGuardar = true;
            this.mostrarFormularioProcesar = false;
            this.mostrarFormularioEditar = false;
            this.mostrarDetalle(response);
          }).catch((err) => {
          console.log('cayo un errorsito' + err);
        });
      } else {
        console.log('guardando');
        this._util.confirmarSincronoPromesa({
          title: this.DAT_MSG.guardar,
          text: '',
          action: this.DAT_BTNS.guardar,
          funcion: this.guardarData()
        })
          .then((response: any) => {
            this.descargarArchivos(response);
            this.mostrarFormularioProcesar = true;
            this.mostrarFormularioGuardar = false;
            this.mostrarFormularioEditar = false;
            this.ngOnInit();
          }).catch((err) => {
          //validar si hay q mostrar el detalle
          // this.mostrarDetalle(err.error.respuesta);
        });
      }
    } else if (event === 'reProcesar') {
      console.log('reprocesando');
      this._util.confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text: '',
        action: this.DAT_BTNS.procesar,
        funcion: this.reProcesar()
      })
        .then((response: any) => {
          this.limpiarIputFile();
          this.mostrarDetalle(response);
        }).catch((err) => {
        console.log('cayo un errorsito' + err);
      });
    }
  }

  mostrarDetalle(response: any) {
    this.rowData = response.comprobante.listPaymentTransactions;
    this.dataCliente = response;
    this.formulario.get('sustento').setValue(null);
    this.btnGuardar = true;
  }

  reProcesar() {
    let newDataArray = this.rowData;
    let data = this.dataCliente;
    delete data.comprobante['listPaymentTransactions'];
    data.comprobante.listPaymentTransactions = newDataArray;
    return this._cobrosAutoservicios.reprocesarArchivo(data);
  }

  guardarData() {
    // debugger
    let newDataArray = this.rowData;
    let data = this.dataCliente;
    delete data.comprobante['listPaymentTransactions'];
    data.comprobante.listPaymentTransactions = newDataArray;
    let JsonString = JSON.stringify(data);
    const formData = new FormData();
    formData.append('data', JsonString);
    // formData.append('file', this.formulario.get('sustento').value);
    formData.append('file', new Blob([this.formulario.get('sustento').value], {type: 'image/png'}), 'file');
    return this._cobrosAutoservicios.guardarCobros(formData);
  }

  regresarFomularioProcesar() {
    this.mostrarFormularioProcesar = true;
    this.mostrarFormularioGuardar = false;
    this.formulario.get('sustento').setValue(null);
  }

  btnEditarRegresar() {
    this.mostrarFormularioGuardar = true;
    this.mostrarFormularioProcesar = false;
    this.mostrarFormularioEditar = false;
  }

  async descargarArchivos(arrayFile: []) {
    for (let i = 0; i < arrayFile.length; i++) {
      const e = arrayFile[i];
      await this.descargarArchivo(e);
    }
  }

  async descargarArchivo(respuesta) {
    let name_file = respuesta.name;
    let archivo = respuesta.content;
    const dataURI = "data:aplication/plain;base64," + (archivo);
    var a = document.createElement("a");
    a.href = dataURI;
    a.setAttribute("download", name_file);
    a.click();
  }


  cargarComponentesModal() {
    this.formularioModal = this.fb.group({
      codigo1: ['', [Validators.required]],
      codigo2: ['', [Validators.required]],
      ruc1: ['', [Validators.required]],
      ruc2: ['', [Validators.required]],
      nombre: ['', [Validators.required]]
    });

    this.frameworkComponentsModal = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsModal = [
      {
        headerName: 'ID',
        field: 'idCliente',
        sortable: true,
        // checkboxSelection: true,
        // headerCheckboxSelection: true,
        width: 150,
        filter: true,
      },
      {
        headerName: 'RUC',
        field: 'rucCliente',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'NOMBRE CLIENTE',
        field: 'nombreCliente1',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 200,
        cellRendererParams: {
          onClick: this.selectLinea.bind(this),
          label: 'Seleccionar',
          colorBoton: 'btn btn-info'
        }
      }
    ];
    this.rowSelectionModal = 'multiple';
    this.rowDataModal = [];
  }

  mostrarTabla() {
    this.loading = true;
    this.mostrar = true;
    let codIni = this.formularioModal.get('codigo1').value;
    let codFin = this.formularioModal.get('codigo2').value;
    let rucIni = this.formularioModal.get('ruc1').value;
    let rucFin = this.formularioModal.get('ruc2').value;
    let nombre = this.formularioModal.get('nombre').value;
    this._inputSearch.getClienteParams(codIni, codFin, rucIni, rucFin, nombre).subscribe((res: any) => {
      this.rowDataModal = res;
      this.loading = false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowDataModal = [];
    });
  }


  mostrarFormulario() {
    this.mostrar = false;
    this.formulario.setValue({
      codigo1: '',
      codigo2: '',
      ruc1: '',
      ruc2: '',
      nombre: ''
    });
    this.rowData = [];
  }

  selectLinea({rowData}) {
    // this.mostrar = false;
    // // this.closebutton.nativeElement.click();
    // this.value = rowData.descripcion;
    // //this.devolverAccion.emit(rowData.idCliente);
    // this.devolverAccion.emit(rowData);
    this.formulario.get('idCliente').setValue(rowData.idCliente);
    this.cargarCliente({});
  }

  callModal(target) {
    document.getElementById('Cliente').click();
  }
}
